var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 513 342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h513v341.3H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.7,230L513,341.3v-31.5L369.3,230L311.7,230z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.3,111.3L0,0v31.5l143.7,79.8H200.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#0052B4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.8,230L513,295.7V230H393.8z M311.7,230L513,341.3v-31.5L369.3,230L311.7,230z M458.6,341.3l-147-81.7 v81.7H458.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3,230L0,280.2V230H90.3z M200.3,244.2v97.2H25.5L200.3,244.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.2,111.3L0,45.6v65.7H118.2z M200.3,111.3L0,0v31.5l143.7,79.8H200.3z M53.4,0l147,81.7V0H53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.7,111.3L513,61.1v50.2H421.7z M311.7,97.1V0h174.9L311.7,97.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288,0h-64v138.7H0v64h224v138.7h64V202.7h224v-64H288V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.7,230L513,341.3v-31.5L369.3,230L311.7,230z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.7,230L0,309.9v31.5L200.3,230L143.7,230z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.3,111.3L0,0v31.5l143.7,79.8H200.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.3,111.3L513,31.5V0L311.7,111.3H368.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/GB.8030d4cc37b42655236f9d24dbc92134.svg";
export { ForwardRef as ReactComponent };